const tag = document.createElement('script')
tag.src = 'https://www.youtube.com/iframe_api'

const firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)


const onYoutubeReadyCallbacks = []
let youtubeReady = false
let YT


window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady()
{
    youtubeReady = true
    YT = window.YT

    while (onYoutubeReadyCallbacks.length > 0)
    {
        onYoutubeReadyCallbacks.pop()()
    }
}


export default class YoutubeManager
{
    constructor(id, iframe, {
        autoplay = true,
        mute = true,
        onReady = null,
        onError = null,
        onPlay = null,
        onPause = null})
    {
        this.id = id
        this.iframe = iframe
        this.lastAction = 'pause'
        this.label = 'https://youtu.be/' + id
        this.options = {autoplay, mute, onReady, onError, onPlay, onPause}

        if (youtubeReady)
        {
            this._init()
        }
        else
        {
            onYoutubeReadyCallbacks.push(this._init)
        }
    }

    _init()
    {
        this.player = new YT.Player(this.iframe, {
            height: '1280',
            width: '720',
            videoId: this.id,
            events: {
                onReady: this._onReady.bind(this),
                onStateChange: this._onStateChange.bind(this),
                onError: this._onError.bind(this)
            },
            playerVars: {
                enablejsapi: 1,
                autoplay: this.options.autoplay ? this.options.autoplay : 0,
                controls: 1,
                fs: 1,
                hl: 1,
                iv_load_policy: 3,
                loop: 0,
                modestbranding: 1,
                // origin
                playsinline: 0,
                rel: 0,
                showinfo: 0,
                mute: this.options.mute ? this.options.mute : 0
            }
        })
    }

    destroy()
    {
        if (this.player)
        {
            YoutubeManager._pushToGTM({
                event: 'gfinity.video',
                'gfinity.video.action': 'close',
                'gfinity.video.resource': this.label
            })
        }
    }

    _onStateChange(event)
    {
        switch (event.data)
        {
        case YT.PlayerState.PLAYING:

            if (this.lastAction !== 'play')
            {
                this.lastAction = 'play'

                YoutubeManager._pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': 'play',
                    'gfinity.video.resource': this.label
                })
            }

            // Callback
            if (typeof this.options.onPlay === 'function')
            {
                this.options.onPlay()
            }

            break

        case YT.PlayerState.PAUSED:

            if (this.lastAction !== 'pause')
            {
                this.lastAction = 'pause'

                YoutubeManager._pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': 'pause',
                    'gfinity.video.resource': this.label
                })
            }

            // Callback
            if (typeof this.options.onPause === 'function')
            {
                this.options.onPause()
            }

            break

        case YT.PlayerState.ENDED:

            if (this.lastAction !== 'stop')
            {
                this.lastAction = 'stop'

                YoutubeManager._pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': 'ended',
                    'gfinity.video.resource': this.label
                })
            }
            break

        default:
            break
        }
    }

    static _pushToGTM(data)
    {
        if (window.dataLayer)
        {
            window.dataLayer.push(data)
        }
        else
        {
            console.error('Google Tag Manager: dataLayer not defined')
        }
    }

    _onReady()
    {
        // Callback
        if (typeof this.options.onReady === 'function')
        {
            this.options.onReady()
        }
    }

    _onError(event)
    {
        console.error('Youtube player error:', event)

        // Callback
        if (typeof this.options.onError === 'function')
        {
            this.options.onError()
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-youtube/YoutubeManager.js